module.exports = __webpack_public_path__ + "static/media/bg.ec591698.jpg";